import { useHistory } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

import { getShafaAbsoluteUrl } from '@utils/common';
import { Product } from '@components/ProductCard';
import { getCollectionPageStructuredData, getItemListStructuredData } from '@utils/structuredData';


type Props = {
  metaTitle: string | null | undefined,
  metaDescription: string | null | undefined,
  productsCount: number,
  products: Product[],
};

export const StructuredData: React.FC<Props> = ({
  metaTitle,
  metaDescription,
  productsCount,
  products,
}) => {
  const history = useHistory();

  if (products.length === 0) {
    return <></>;
  }
  const url = getShafaAbsoluteUrl(history.createHref({ pathname: history.location.pathname }));
  const itemListStructuredData = getItemListStructuredData(
    metaTitle,
    url,
    productsCount,
    products,
  );
  const collectionPageStructuredData = getCollectionPageStructuredData(
    metaTitle,
    metaDescription,
    url,
    products,
  );
  return (
    <Helmet>
      <script type='application/ld+json'>
        {JSON.stringify(itemListStructuredData)}
      </script>
      <script type='application/ld+json'>
        {JSON.stringify(collectionPageStructuredData)}
      </script>
    </Helmet>
  );
};
